import { BaseSensor as Sensor } from './BaseSensor';
export class TimeFrame{
	begin:Date;
	end:Date;
	day:number;
	sensor: Sensor;
	id:number;
	ignoreTemperature :boolean = true;
	static _id = 0;
	constructor(){
		this.setBegin(new Date());
		this.setEnd(new Date());
		this.day = 0;
		this.sensor = new Sensor();
		this.sensor.setMinValue(5);
		this.sensor.setMaxValue(30);
		this.sensor.setUnit("STD_UNIT_CELSIUS_NORMAL_LEFT");
		this.sensor.setCurrentValue(20);//default 20
		this.sensor.setGranularity(0.5);
		this.id = TimeFrame._id;
		TimeFrame._id++;

	}
	copy(frame : TimeFrame){
		this.setBegin(new Date(frame.getBegin().getTime()));
		this.setEnd(new Date(frame.getEnd().getTime()));
		this.setIgnoreTemperature(frame.isIgnoringTemperature());
		this.setDay(frame.getDay());
		this.sensor.setMinValue(frame.getSensor().getMinValue());
		this.sensor.setUnit(frame.getSensor().getUnit());
		this.sensor.setMaxValue(frame.getSensor().getMaxValue());
		this.sensor.setCurrentValue(frame.getSensor().getCurrentValue());


	}
	public setIgnoreTemperature( b : boolean ) : void{
		this.ignoreTemperature = b;
	}
	public isIgnoringTemperature(){
		return this.ignoreTemperature;
	}

	getStartRelative():number{
		return ((this.begin.getHours()*60)+(this.begin.getMinutes()))/(60*24);
	}

	getEndRelative():number{
		return ((this.end.getHours()*60)+(this.end.getMinutes()))/(60*24);
	}

	getDurationRelative():number{
		return this.getEndRelative()-this.getStartRelative();
	}

	getDay():number{
		return this.day;
	}

	setDay(day:number):void{
		if(day >= 0 && day < 7){			
			this.day = day;
		}else{
			this.debug("day has to be >0 and <7");
		}
	}
	overlapsWith(tf: TimeFrame):boolean{
		let tBegin = this.toNumber(this.begin);
		let oBegin = this.toNumber(tf.getBegin());
		let tEnd = this.toNumber(this.end);
		let oEnd = this.toNumber(tf.getEnd());

		if(tBegin >= oEnd || oBegin >= tEnd){
			return false;
		}
		console.log("Begin: "+tBegin);
		console.log("End:" +tEnd);
		console.log("Comparison: Begin"+oBegin);
		console.log("Comparison: End"+oEnd);
		return true;
	}
	toNumber(date:Date):number{
		return date.getHours()*100+date.getMinutes();
	}
	contains(date : Date):boolean{
		return this.toNumber(date) >= this.toNumber(this.begin) && this.toNumber(date) <= this.toNumber(this.end);
		//return (date.getTime() >= this.begin.getTime() && date.getTime() <= this.end.getTime());

	}
	containsStrict(date : Date):boolean{
		return this.toNumber(date) > this.toNumber(this.begin) && this.toNumber(date) < this.toNumber(this.end);
		//return (date.getTime() >= this.begin.getTime() && date.getTime() <= this.end.getTime());

	}

	getId():number{
		return this.id;
	}
	setId(id:number):void{
		this.id = id;
	}

	getBegin():Date{
		return this.begin;
	}
	getEnd():Date{
		return this.end;
	}
	getValue() : number{
		return this.sensor.getCurrentValue();
	}
	setValue(val:number):void{
		this.sensor.setCurrentValue(val);
	}
	getSensor() : Sensor{
		return this.sensor;
	}
	getStringFor(date : Date):string{
		let hours = date.getHours()+"";
		if(hours.length != 2){
			hours="0"+hours;
		}
		let minutes = date.getMinutes()+"";
		if(minutes.length != 2){
			minutes = "0"+minutes;
		}
		return hours+":"+minutes;
 
	}
	intervalString():string{
		return this.getStringFor(this.begin)+ " - "+this.getStringFor(this.end);
	}
	increaseBegin():void{
		this.begin.setTime(this.begin.getTime()+60*1000);
	}
	
	decreaseBegin():void{
		this.begin.setTime(this.begin.getTime()-60*1000);
	}

	increaseEnd():void{
		this.end.setTime(this.end.getTime()+60*1000);
	}
	
	decreaseEnd():void{
		this.end.setTime(this.end.getTime()-60*1000);
	}
	
	setBegin(date : Date): void{
		this.begin = date;
		this.begin.setSeconds(0);
		this.begin.setMilliseconds(0);
		this.debug("Setting begin to "+this.begin.getHours() + " on day " + this.day);
	}
	
	setEnd(date : Date) : void{
		
		this.end = date;
		this.end.setSeconds(0);
		this.end.setMilliseconds(0);
		this.debug("Setting end to "+this.end.getHours() + " on day " + this.day);
	}

	toString(debug?:boolean):string{
		if(debug){
			return "[id: "+this.getId()+ ", "+this.getStringFor(this.begin)+" - "+this.getStringFor(this.end)+ ": "+this.sensor.toString()+ " day: "+this.getDay()+"]";	
		}else{
			let retStr = this.getStringFor(this.begin)+" - "+this.getStringFor(this.end);
			if(!this.ignoreTemperature){
				retStr +=": "+this.sensor.toString();
			}
			return retStr;
		}
		
	}


	bucket:string;
	setBucket(bucket:string){
		this.bucket=bucket;
	}
	getBucket():string{
		return this.bucket;
	}


	private static _debug=false;

	static enableDebugging(){
		TimeFrame._debug = true;
	}
	static disableDebugging(){
		TimeFrame._debug = false;
	}
	static isDebugging(){
		return TimeFrame._debug;
	}

	debug(msg: string): void {
		if(!TimeFrame.isDebugging()){
			return;
		}
		console.log("TimeFrame: " + msg);
	}
}